import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { IDS } from "@/lib/ids";

const YEAR = new Date().getFullYear();

const FOOTER_COLS = [
  { label: "Product", items: [
    { id: "product",    label: "Overview",   href: "/#product" },
    { id: "mechanism",  label: "Mechanism",  href: "/#mechanism" },
    { id: "frameworks", label: "Frameworks", href: "/#frameworks" },
    { id: "trust",      label: "Trust",      href: "/#trust" },
    { id: "pricing",    label: "Pricing",    href: "/#pricing" },
  ]},
  { label: "Company", items: [
    { id: "founders", label: "About",           href: "/#founders" },
    { id: "contact",  label: "daksh@normshift.in", href: "mailto:daksh@normshift.in", external: true },
    { id: "demo",     label: "Request demo",   href: "/#demo" },
  ]},
  { label: "Legal", items: [
    { id: "privacy", label: "Privacy Policy", href: "/privacy", route: true },
  ]},
];

export default function Footer() {
  return (
    <footer className="relative hairline-t pt-20 pb-10 overflow-hidden">
      {/* fold motif — echoes logo crease */}
      <div className="absolute inset-x-0 top-0 pointer-events-none" aria-hidden>
        <svg viewBox="0 0 1400 120" className="w-full h-[80px]" preserveAspectRatio="none">
          <path d="M 0 120 L 700 20 L 1400 120 Z" fill="none" stroke="var(--hairline-strong)" />
          <path d="M 0 120 L 700 55 L 1400 120 Z" fill="none" stroke="var(--hairline)" />
        </svg>
      </div>

      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <Chapter />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-5">
            <motion.h2
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.6 }}
              className="font-display text-[42px] md:text-[62px] leading-[1.02] tracking-[-0.022em] text-balance"
            >
              Collect once. <br /> Comply <span className="grad-text">many</span>.
            </motion.h2>
            <a href="/#demo" data-testid={IDS.finalCta} className="cta mt-8">
              Request a demo
              <span aria-hidden>→</span>
            </a>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 md:grid-cols-3 gap-8">
            {FOOTER_COLS.map((c) => (
              <div key={c.label}>
                <div className="font-mono text-[10px] tracking-[0.24em] uppercase text-ink-muted mb-4">{c.label}</div>
                <ul className="space-y-2.5">
                  {c.items.map((it) => (
                    <li key={it.id}>
                      {it.route ? (
                        <Link
                          to={it.href}
                          data-testid={IDS.footerLink(it.id)}
                          className="text-[13px] text-white/70 hover:text-white transition-colors nav-link"
                        >
                          {it.label}
                        </Link>
                      ) : (
                        <a
                          href={it.href}
                          data-testid={IDS.footerLink(it.id)}
                          className="text-[13px] text-white/70 hover:text-white transition-colors nav-link"
                        >
                          {it.label}
                        </a>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Legal entity strip */}
        <div className="hairline-t pt-6 pb-4 grid grid-cols-1 md:grid-cols-2 gap-6 items-center">
          <div className="flex items-center">
            <img
              src="https://customer-assets.emergentagent.com/job_comply-once/artifacts/xt12uxrp_Transparent%20Logo.webp"
              alt="NormShift"
              className="h-8 w-auto object-contain footer-logo-light"
            />
          </div>

          <div className="md:text-right font-mono text-[10.5px] tracking-[0.14em] text-white/40">
            © {YEAR} NormShift · All rights reserved
          </div>
        </div>
      </div>
    </footer>
  );
}

function Chapter() {
  return (
    <div className="flex items-center gap-4 mb-10">
      <span className="font-mono text-[11px] text-ink-muted tracking-[0.28em]">CH · 13 · The fold closes</span>
      <span className="h-px flex-1 bg-white/10" />
    </div>
  );
}
